var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-template',{attrs:{"toolbar":_vm.toolbar}},[_c('group-form',{ref:"groupForm",attrs:{"loading":_vm.loading},on:{"submit":_vm.groupCreate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }